import { validateEnumTranslations } from '../../safety_checks';

//⚠️IMPACT attention changer dans le fichier prisma l'enum pro_resource_category
export enum ProResourceCategory {
  VEHICLE = 'VEHICLE',
  ROOM = 'ROOM',
  EQUIPMENT = 'EQUIPMENT',
}

//⚠️IMPACT attention changer dans le fichier prisma l'enum pro_resource_booking_mode
export enum ProResourceBookingMode {
  CONSTRAINT = 'CONSTRAINT',
  SELECTABLE = 'SELECTABLE',
  // Auto-affectation d'exactement UNE ressource libre parmi les liées (sémantique OR).
  POOL = 'POOL',
}

//⚠️IMPACT attention changer dans le fichier prisma l'enum pro_resource_type
export enum ProResourceType {
  REUSABLE = 'REUSABLE',
  CONSUMABLE = 'CONSUMABLE',
}

export const PRO_RESOURCE_CATEGORY_TRANSLATE_KEY = 'PRO_RESOURCE_CATEGORY_';
export const PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY = 'PRO_RESOURCE_BOOKING_MODE_';

export const ProResourceCategoryTranslation = {
  'fr-FR': {
    [`${PRO_RESOURCE_CATEGORY_TRANSLATE_KEY}${ProResourceCategory.VEHICLE}`]: 'Véhicule',
    [`${PRO_RESOURCE_CATEGORY_TRANSLATE_KEY}${ProResourceCategory.ROOM}`]: 'Salle',
    [`${PRO_RESOURCE_CATEGORY_TRANSLATE_KEY}${ProResourceCategory.EQUIPMENT}`]: 'Matériel',
  },
};

export const ProResourceBookingModeTranslation = {
  'fr-FR': {
    [`${PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY}${ProResourceBookingMode.CONSTRAINT}`]: 'Contrainte invisible',
    [`${PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY}${ProResourceBookingMode.SELECTABLE}`]: 'Choix client',
    [`${PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY}${ProResourceBookingMode.POOL}`]: 'Flotte (attribution auto)',
  },
};

validateEnumTranslations(
  ProResourceCategory,
  ProResourceCategoryTranslation,
  PRO_RESOURCE_CATEGORY_TRANSLATE_KEY,
  true,
);
validateEnumTranslations(
  ProResourceBookingMode,
  ProResourceBookingModeTranslation,
  PRO_RESOURCE_BOOKING_MODE_TRANSLATE_KEY,
  true,
);
